import { computed, defineComponent, onUnmounted } from '@vue/composition-api';
import PageFAQ from '@/components/PageFAQ.vue';
import { PRICING_TIERS } from '@/static-pages/pricing.const';
import { useMeta } from '@/shared/composables/useMeta';
import useStructuredData from '@/shared/composables/useStructuredData';
import { SITE_URL } from '@/App.vue';
const LICENCE_INCLUDES = [
    'vendors',
    'requests',
    'payments',
    'theming',
    'updates',
    'export'
];
const INSTALL_STEPS = ['licence', 'install', 'domain', 'vendors'];
const FAQ_KEYS = ['who', 'support', 'updates', 'migrate'];
export default defineComponent({
    components: { PageFAQ },
    setup(_, context) {
        const { root } = context;
        const { injectStructuredData, ejectStructuredData } = useStructuredData();
        const faqQuestions = computed(() => FAQ_KEYS.map((key) => ({
            question: root.$i18n.t(`selfhosted.faq.${key}.question`),
            answer: root.$i18n.t(`selfhosted.faq.${key}.answer`)
        })));
        useMeta({
            title: root.$i18n.t('selfhosted.meta.title'),
            description: root.$i18n.t('selfhosted.meta.description'),
            url: `${SITE_URL}${window.location.pathname}`,
            noIndex: false
        });
        onUnmounted(() => {
            ejectStructuredData();
        });
        return {
            faqQuestions,
            installSteps: INSTALL_STEPS,
            licence: PRICING_TIERS.find(tier => tier.licence),
            licenceIncludes: LICENCE_INCLUDES,
            injectStructuredData
        };
    }
});
